import React from 'react';
import Alert, { AlertType } from '../../Shared/components/Alert';
import '../real-estate.scss';
import Projects from './Project/Projects';
import Units from './Unit/Units';
import FeaturedUnits from './Unit/FeaturedUnits';
const RealEstate = ({ type }) => {
    const renderType = () => {
        switch (type) {
            case 'project':
                return React.createElement(Projects, null);
            case 'unit':
                return React.createElement(Units, null);
            case 'unit-featured':
                return React.createElement(FeaturedUnits, null);
            default:
                return React.createElement(Alert, { message: "Real-estate type not available or supported", type: AlertType.error });
        }
    };
    return renderType();
};
export default RealEstate;
